import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import 'rxjs/Rx';
import { OAuthToken } from '../../models/oAuthToken.model';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthTokenService {
    private _authToken: OAuthToken;
    private _tempStr: '';
    private _promise: Promise<any>;
    private _promiseDone = false;
    constructor(private http: HttpClient, protected localStorage: LocalStorage) {}

    swapToken(tempToken: string): Promise<any> {
        //const tokenEndPoint = 'http://localhost:58830/token';
        const tokenEndPoint = environment.tokenEndpoint;
        this._authToken = {access_token: '', expires_in: '', token_type: ''};
        if (this._promiseDone) {
            return Promise.resolve(); }
        if (this._promise != null) {
            return this._promise; }
        this._promise = this.http
        .post(tokenEndPoint, `client_id=eAuthClient&client_secret=${tempToken}&grant_type=client_credentials`)
        .map((resp: Response) => resp)
        .toPromise()
        .then((data: any) => {
            console.log('In AuthTokenService');

            this._authToken = data;
            this._promiseDone = true;

            // store OAuth token in async local storage
            this.localStorage.setItem('oauth_token', this._authToken).subscribe(() => {});

            return this._authToken;
        }).catch((err: any) => {
        
            this._promiseDone = true;
            return Promise.resolve();
        });
        return this._promise;
    }

    get AuthToken(): OAuthToken {
        return this._authToken;
    }

    set AuthToken (token: OAuthToken) {
        this._authToken = token;
    }

    get TempStr(): string {
        return this._tempStr;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/services/appInitialization/authToken.service.ts